import Vue from 'vue'
import Router from 'vue-router'
import LoginComponent from "./components/login.vue"
import HomeComponent from "./components/home.vue"
import SplashComponent from "./components/splash.vue"
import PictureComponent from "./components/picture.vue"
import BuildingComponent from "./components/building.vue"
import InquiryComponent from "./components/inquiry.vue"
import InterventionComponent from "./components/intervention.vue"
import QuotationComponent from "./components/quotation.vue"
import InvoiceComponent from "./components/invoice.vue"
import InterventionDetail from "./components/interventiondetail.vue"
import Invoicepay from "./components/invoicepay.vue"
import Payment from "./components/payment.vue"
import Password from "./components/password.vue"
import Adminhome from "./components/adminhome.vue"
import BuildingList from "./components/buildinglist.vue"
import BuildingDetail from "./components/buildingdetail.vue"
import Buildinginqlist from "./components/buildinginqlist.vue"
import InquiryAdmin from "./components/inquiryadmin.vue"
import InterventionAdmin from "./components/interventionadmin.vue"
import InterventionDetailAdmin from "./components/interventiondetailadmin.vue"
import InvoiceAdmin from "./components/invoiceadmin.vue"
import QuotationAdmin from "./components/quotationadmin.vue"
import Newbuilding from "./components/newbuilding.vue"
import Modifybuilding from "./components/modifybuilding.vue"
import Planningadmin from "./components/planningadmin.vue"
import Inquirydocumentsadmin from "./components/inquirydocumentsadmin.vue"
import Newinquiry from "./components/newinquiry.vue"
import Newintervention from "./components/newintervention.vue"
import Modifyinquiry from "./components/modifyinquiry.vue"
import Modifyintervention from "./components/modifyintervention.vue"
import Timesheet from "./components/timesheet.vue"
import Timesheetdetail from "./components/timesheetdetail.vue"
import Newuser from "./components/newuser.vue"
import Userdetail from "./components/userdetail.vue"
import Modifyuser from "./components/modifyuser.vue"
import Alluser from "./components/alluser.vue"
import Newgroup from "./components/newgroup.vue"
import Allgroup from "./components/allgroup.vue"
import Modifygroup from "./components/modifygroup.vue"
import Groupdetail from "./components/groupdetail.vue"
import Techhome from "./components/techhome.vue"
import Startintervention from "./components/startintervention.vue"
import Interventiondetailtech from "./components/interventiondetailtech.vue"
import Cerfatva from "./components/cerfatva.vue"
import Cerfagaz from "./components/cerfagaz.vue"
import Cerfafioul from "./components/cerfafioul.vue"
import Cerfaclim from "./components/cerfaclim.vue"

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            redirect: {
                name: "splash"
            }
        },
        {
            path: "/login",
            name: "login",
            component: LoginComponent
        },
        {
            path: "/home",
            name: "home",
            component: HomeComponent
        },
        {
            path: "/splash",
            name: "splash",
            component: SplashComponent
        },
        {
            path: "/picture",
            name: "picture",
            component: PictureComponent
        },
        {
            path: "/building",
            name: "building",
            component: BuildingComponent
        },
        {
            path: "/inquiry",
            name: "inquiry",
            component: InquiryComponent
        },
        {
            path: "/intervention",
            name: "intervention",
            component: InterventionComponent
        },
        {
            path: "/quotation",
            name: "quotation",
            component: QuotationComponent
        },
        {
            path: "/invoice",
            name: "invoice",
            component: InvoiceComponent
        },
        {
            path: "/interventiondetail",
            name: "interventiondetail",
            component: InterventionDetail
        },
        {
            path: "/invoicepay",
            name: "invoicepay",
            component: Invoicepay
        },
        {
            path: "/payment",
            name: "payment",
            component: Payment
        },
        {
            path: "/password",
            name: "password",
            component: Password
        },
        {
            path: "/adminhome",
            name: "adminhome",
            component: Adminhome
        },{
            path: "/buildinglist",
            name: "buildinglist",
            component: BuildingList
        },{
            path: "/buildingdetail",
            name: "buildingdetail",
            component: BuildingDetail
        },{
            path: "/buildinginqlist",
            name: "buildinginqlist",
            component: Buildinginqlist
        },{
            path: "/inquiryadmin",
            name: "inquiryadmin",
            component: InquiryAdmin
        },{
            path: "/interventionadmin",
            name: "interventionadmin",
            component: InterventionAdmin
        },{
            path: "/interventiondetailadmin",
            name: "interventiondetailadmin",
            component: InterventionDetailAdmin
        },{
            path: "/invoiceadmin",
            name: "invoiceadmin",
            component: InvoiceAdmin
        },{
            path: "/quotationadmin",
            name: "quotationadmin",
            component: QuotationAdmin
        },{
            path: "/newbuilding",
            name: "newbuilding",
            component: Newbuilding
        },{
            path: "/modifybuilding",
            name: "modifybuilding",
            component: Modifybuilding
        },{
            path: "/planningadmin",
            name: "planningadmin",
            component: Planningadmin
        },{
            path: "/inquirydocumentsadmin",
            name: "inquirydocumentsadmin",
            component: Inquirydocumentsadmin
        },{
            path: "/newinquiry",
            name: "newinquiry",
            component: Newinquiry
        },{
            path: "/newintervention",
            name: "newintervention",
            component: Newintervention
        },{
            path: "/modifyinquiry",
            name: "modifyinquiry",
            component: Modifyinquiry
        },{
            path: "/modifyintervention",
            name: "modifyintervention",
            component: Modifyintervention
        },{
            path: "/timesheet",
            name: "timesheet",
            component: Timesheet
        },{
            path: "/timesheetdetail",
            name: "timesheetdetail",
            component: Timesheetdetail
        },{
            path: "/newuser",
            name: "newuser",
            component: Newuser            
        },{
            path: "/userdetail",
            name: "userdetail",
            component: Userdetail
        },{
            path: "/modifyuser",
            name: "modifyuser",
            component: Modifyuser
        },{
            path: "/alluser",
            name: "alluser",
            component: Alluser
        },{
            path: "/newgroup",
            name: "newgroup",
            component: Newgroup            
        },{
            path: "/allgroup",
            name: "allgroup",
            component: Allgroup
        },{
            path: "/modifygroup",
            name: "modifygroup",
            component: Modifygroup
        },{
            path: "/groupdetail",
            name: "groupdetail",
            component: Groupdetail
        },{
            path: "/techhome",
            name: "techhome",
            component: Techhome
        },{
            path: "/startintervention",
            name: "startintervention",
            component: Startintervention            
        },
        {
            path: "/interventiondetailtech",
            name: "interventiondetailtech",
            component: Interventiondetailtech
        },
        {
            path: "/cerfatva",
            name: "cerfatva",
            component: Cerfatva
        },
        {
            path: "/cerfagaz",
            name: "cerfagaz",
            component: Cerfagaz
        },
        {
            path: "/cerfafioul",
            name: "cerfafioul",
            component: Cerfafioul
        },
        {
            path: "/cerfaclim",
            name: "cerfaclim",
            component: Cerfaclim
        }
    ]
})